import { FunctionComponent } from 'react';

import { CircularProgress } from '@mui/material';
import { useTranslation } from 'react-i18next';

import BreakoutRoomOptionsBody from './BreakoutRoomOptionsBody';
import BreakoutRoomOptionsHeader from './BreakoutRoomOptionsHeader';

const BreakoutRoomOptions: FunctionComponent = () => {
    const { ready } = useTranslation();

    if (ready) {
        return (
            <>
                <BreakoutRoomOptionsHeader />
                <BreakoutRoomOptionsBody />
            </>
        );
    }

    return <CircularProgress />;
};

export default BreakoutRoomOptions;
